<template>
    <v-dialog  class="pa-0 display-unset" v-model="dialog" width="1000">
      <v-btn class="right" icon slot="activator">
        <v-icon large class="text-white f-20" >far fa-question-circle</v-icon>
      </v-btn>
      <!--<v-btn color="primary right card-r no-shadow" @click="save" slot="activator" dark>Finish</v-btn>-->
      <div class="Login">
        <v-container fluid grid-list-md class="pt-0">
          <v-layout row wrap align-center>
            <v-flex class="text-xs-center" xs12 lg12>
              <v-card class="white no-shadow pa-3 card-r grey lighten-4">
                <v-toolbar class="tow-clor-1 card-r mb-2 shadow-1 pl-3 text-white">
                  <div class="text-xs-left f-17 text-capitalize mr-2">Help - Use Admin Panel</div>
                  <div class="text-xs-center f-12 hidden-xs-only hidden-sm-only">(How to create your school in simple way?)</div>
                  <v-spacer></v-spacer>
                  <v-btn class="white card-r mr-3" icon @click="dialog = false">
                    <v-icon class="text-primary" >close</v-icon>
                  </v-btn>

                </v-toolbar>
              <div class=" grey lighten-4 card-r no-shadow">
                <!--<v-flex class="possition-fixed grey lighten-4">-->
                  <!--<v-icon class="textColor right pt-3 pr-3" @click="dialog = false">close</v-icon>-->

                  <!--<h1 class="display-1 font-weight-medium pt-3 pl-5">Help - Use Admin Panel</h1>-->
                <!--</v-flex>-->
                <v-form row>
                  <template>
                    <v-stepper v-model="createSchool" class="card-r no-shadow grey lighten-4">
                      <v-layout wrap>
                        <v-flex md3 sm3 xs3 lg12 class="dddfdse">
                          <v-stepper-header class=" card-r no-shadow grey lighten-4">
                            <v-stepper-step xs4 :complete="createSchool > 1" step="1">Create Classes</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step xs4 :complete="createSchool > 2" step="2">Create Packages</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step xs4 :complete="createSchool > 3" step="3">Create Teachers</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step xs4 :complete="createSchool > 4" step="4">Create Students</v-stepper-step>
                          </v-stepper-header>
                        </v-flex>
                        <v-flex md9 sm12 xs12 lg12 class="pt-0">
                          <v-stepper-items class="grey lighten-4">
                            <v-stepper-content step="1" class=" mb-5 pt-0">
                              <div class="text-xs-center f-15">Step 1 of 4</div>
                              <!-- This is page 01 - Create Class -->
                                <createClass/>
                              <v-btn color="tow-clor-1 text-white right card-r no-shadow mb-5"  @click="loadClasses()">Next</v-btn>
                              <!-- This is page 01 - Create Class -->
                            </v-stepper-content>

                            <v-stepper-content step="2" class="pt-0">
                              <div class="text-xs-center f-15">Step 2 of 4</div>
                              <!-- This is page 02 - Create Package  -->
                                <CreatePackage v-if="showPackageComp"/>
                              <!-- This is page 02 - Create Package  -->
                              <v-btn class="tow-clor-1 text-white right card-r no-shadow"  @click="loadPackages()">Next</v-btn>
                              <v-btn class="right tow-clor-grey text-white card-r no-shadow"  @click="createSchool =  1,showPackageComp=false">back</v-btn>
                            </v-stepper-content>

                            <v-stepper-content step="3" class="pb-5 mb-5 pt-0">
                              <div class="text-xs-center f-15">Step 3 of 4</div>
                              <!-- This is page 03 - Create Teacher  -->
                                <AddNewTeacher v-if="showTeacherComp"/>
                              <!-- This is page 03 - Create Teacher  -->

                              <v-btn color="tow-clor-1 text-white right card-r no-shadow mb-5"  @click="loadTeachers()">Next</v-btn>
                              <v-btn @click="createSchool =  2,showTeacherComp=false" class="right tow-clor-grey text-white card-r no-shadow">Back</v-btn>
                            </v-stepper-content>

                            <v-stepper-content step="4" class="pb-5 mb-5 pt-0">
                              <div class="text-xs-center f-15">Step 4 of 4</div>
                              <!-- This is page 04 - Create Student  -->
                                <AddNewStudent v-if="showStudentComp"/>
                              <!-- This is page 04 - Create Student  -->
                              <v-btn color="tow-clor-1 right text-white card-r no-shadow mb-5"  @click="dialog = false">Finish</v-btn>

                              <v-btn @click="createSchool =  3,showStudentComp=false" class="right tow-clor-grey text-white card-r no-shadow">Back</v-btn>

                            </v-stepper-content>

                          </v-stepper-items>
                        </v-flex>
                      </v-layout>
                    </v-stepper>

                  </template>
                </v-form>
              </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

      </div>
    </v-dialog>
</template>
<script>
  /* eslint-disable */
  import DateDropdown from 'vue-date-dropdown'
  import createClass from "@/components/pages/WidgetComponents/CreateClass"
  import CreatePackage from "@/components/pages/WidgetComponents/CreatePackage"
  import AddNewTeacher from "@/components/pages/WidgetComponents/AddNewTeacher"
  import AddNewStudent from "@/components/pages/WidgetComponents/AddNewStudent"
  export default {
    components: {
      DateDropdown,
      createClass,
      CreatePackage,
      AddNewTeacher,
      AddNewStudent
    },
    data: () => ({
      seen: true,
      createSchool: 0,
      dialog: false,
      showPackageComp:false,
      showStudentComp:false,
      showTeacherComp:false,
    }),
    watch: {},
    created() {},
    methods: {
      loadClasses(){
        Store.dispatch('Modules/getAllClasses')
        this.createSchool = 2
        this.showPackageComp=true
      },
      loadPackages(){
        Store.dispatch('Modules/getAllClasses')
        this.createSchool = 3
        this.showTeacherComp=true
      },
      loadTeachers(){
        Store.dispatch("Teachers/getAllTeachers")
        this.createSchool = 4
        this.showStudentComp=true
      },

    }
  };
</script>

<style>
  ::-webkit-scrollbar {
    display: none;
  }
  .pointer {cursor: pointer;}

  .cell {cursor: cell;}
  .list-dbg{
    background: white;
    padding: 10px;
    height: 156px;
    border-radius: 12px;
  }
  .time-ssrl{
    padding: 0px 5px 0px 5px;
  }
  ul ::-webkit-scrollbar {
    display: none;
  }
  .btn-customer{
    margin: 6px 0px 6px 0px !important;
    height: 45px;
    width: 100%;
  }
  .text-white{
    color: #ffffff!important;
  }
  li {
    scroll-snap-stop: always;
  }
  .containerr {
    display: flex;
    padding: 0px !important;
    overflow: auto;
    outline: 1px dashed lightgray;
    flex: none;
  }

  .date-dropdown-select[data-v-67d74744] {
    /* border: 1px solid #0051a0 !important; */
    padding: 4px 20px!important;
  }
  .containerr.x {
    width: 100%;
    height: 128px;
    flex-flow: row nowrap;
  }

  .containerr.y {
    height: 100px;
    flex-flow: column nowrap;
  }
  .y.proximity-scroll-snapping {
    scroll-snap-type: y proximity;
  }
  .containerr > div {
    text-align: center;
    scroll-snap-align: center;
    flex: none;
  }

  .y.containerr > div {
    line-height: 100px;
    font-size: 30px;
    width: 100%;
    height: 100px;
    color: #fff;
  }
  .containerr > div:nth-child(even) {
    background-color: #0051a0;
    margin-top: 2px;
  }

  .containerr > div:nth-child(odd) {
    margin-top: 2px;
    background-color: #0051a0 !important;
  }




















  .list-bg{
    background: #e6e6e6;
    padding: 10px;
    border-radius: 12px;
  }
  .v-tabs__item{
    padding: 3px 3px !important;
  }
  /*.time-srl{*/
  /*height: 30px;*/
  /*font-size: 15px;*/
  /*list-style-type: none;*/
  /*padding: 5px;*/
  /*color: #095697 !important;*/
  /*overflow: scroll;*/
  /*}  */
  .time-srl{
    height: 74px;
    z-index: 1;
    font-size: 17px;
    list-style-type: none;
    padding: 25px 5px 25px 5px;
    color: #095697 !important;
    overflow: scroll;
  }
  ul ::-webkit-scrollbar {
    display: none;}
  .active{
    vertical-align: middle;
    /*font-size: 15px;*/
    /*font-weight: bold;*/
    align-items: center;
    /*text-align: center;*/
  }

  /*ul li:active ,hover{*/
  /*font-size: 15px;*/
  /*font-weight: bold;*/
  /*align-items: center;*/
  /*}*/
  .v-progress-circular{
    margin: 1rem;
  }
  .card-pop{
    z-index: -4;
    margin-top: -12%;
  }
  .v-dialog{
    box-shadow: none!important;
  }
  .btn-customer{
    margin: 6px 0px 6px 0px !important;
    height: 45px;
    width: 100%;
  }
  .text-white{
    color: #ffffff!important;
  }
  .ccc{
    height: 35px!important;
    width: 94%!important;
    z-index: 0!important;
    border-bottom: 1px solid!important;
    border-top: 1px solid!important;
    left: 10px!important;
    top: 120px!important;
    position: absolute!important;
  }
  .theme--light.v-tabs__bar {
    background-color: transparent!important;
  }


  .transparent{
    background-color: transparent!important;
  }
  /*.v-stepper__header {*/
    /*margin: 24px 0px 0px 20px ;*/
    /*display: table;*/
    /*overflow: hidden;*/
  /*}*/
  .theme--light.v-stepper {
    height: 77vh;
    /*height: 378px;*/
    overflow: -moz-scrollbars-none;
  }
  .Formcard{
    height: -webkit-fill-available!important;
  }
  .theme--light.v-stepper .v-stepper__step__step, .theme--light.v-stepper .v-stepper__step__step .v-icon {
    color: #fff;
    padding: 15px;
    font-size: 12px;
  }
  .v-stepper__step{
    padding:  11px 48px 11px 20px;
  }
  .v-stepper__content {
    overflow: auto;
    height: -webkit-fill-available;
    /*height: 100%;*/
  }
  /* Smartphones (portrait and landscape) ----------- */
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
    .v-stepper__header{
      display: none!important;
    }
    .v-stepper__content{
      padding: 0px !important;
    }
    .Formcard {
      height: -webkit-fill-available!important;
    }
  }
  .v-dialog{
    box-shadow: none!important;
  }
  /* Smartphones (landscape) ----------- */
  @media only screen and (min-width : 321px){
    .v-stepper__header{
      display: none!important;
    }
  }

  /* Smartphones (portrait) ----------- */
  @media only screen and (max-width : 320px) {
    .v-stepper__header{
      display: none!important;
    }
  }


  /* iPhone 4 ----------- */
  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) and (orientation : landscape) and (-webkit-min-device-pixel-ratio : 2) {
    .v-stepper__header{
      display: none!important;
    }
  }

  @media only screen and (min-device-width : 320px) and (max-device-width : 480px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio : 2) {
    .v-stepper__header{
      display: none!important;
    }
  }



  /* iPads (portrait and landscape) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) {
    .v-stepper__header{
      display: none!important;
    }
  }

  /* iPads (landscape) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) {
    .v-stepper__header{
      display: none!important;
    }
  }

  /* iPads (portrait) ----------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
    .v-stepper__header{
      display: none!important;
    }
  }

  /* iPad 3 ---------------- */
  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : landscape) and (-webkit-min-device-pixel-ratio : 2) {
    .v-stepper__header{
      display: none!important;
    }
  }

  @media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) and (-webkit-min-device-pixel-ratio : 2) {
    .v-stepper__header{
      display: none!important;
    }
  }


  /* Desktops and laptops ----------- */
  @media only screen and (min-width : 1224px) {
    .v-stepper__header{
      display: flex !important;
    }
  }

  /* 960px layouts ----------- */
  @media only screen and (min-width : 960px){
    .v-stepper__header{
      display: flex!important;
    }
  }

  /* Large screens ----------- */
  @media only screen and (min-width : 1824px) {
    .v-stepper__header{
      display: flex!important;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/pages/Widset.vue